import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=54a7f0d6&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54a7f0d6')) {
      api.createRecord('54a7f0d6', component.options)
    } else {
      api.reload('54a7f0d6', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=54a7f0d6&", function () {
      api.rerender('54a7f0d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ui3bmJD7PLiK/JS/comp/pricelist.vue"
export default component.exports